module.exports = __webpack_public_path__ + "static/media/blog3_2.1ad23bfb.webp";